export type CreditTemplateCategory =
  | '회원가입'
  | '수거신청'
  | '챌린지'
  | '매거진'
  | '커뮤니티'
  | '관리자 지정';

export class CreditTemplateDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  category: CreditTemplateCategory | string;
  title: string;
  credit: number;
  isActive: boolean;
  isEditable: boolean;

  constructor() {
    this.title = '';
    this.credit = 0;
    this.isActive = true;
    this.isEditable = true;
  }
}
